import { render, staticRenderFns } from "./ProfitCustomersTable.vue?vue&type=template&id=66fdd35d"
import script from "./ProfitCustomersTable.vue?vue&type=script&lang=js"
export * from "./ProfitCustomersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports